import {Component, inject, input, OnInit, signal, WritableSignal} from '@angular/core';
import {connectToggleRefinement} from 'instantsearch.js/es/connectors';
import {ToggleRefinementRenderState} from 'instantsearch.js/es/connectors/toggle-refinement/connectToggleRefinement';

import {InstantSearchComponent} from '@core/instantsearch/components/instantsearch.component';
import {TypedBaseWidgetComponent} from '@core/instantsearch/types-based-widget';
import {TrackEventService} from '@core/services/track-event.service';


@Component({
  selector: 'app-instantsearch-toggle',
  templateUrl: './instantsearch-toggle.component.html',
  styleUrls: ['./instantsearch-toggle.component.scss'],
  imports: []
})
export class InstantsearchToggleComponent extends TypedBaseWidgetComponent<any, any> implements OnInit {
  instantSearchInstance = inject(InstantSearchComponent);
  private trackEventService = inject(TrackEventService);


  public readonly attribute = input<string>();
  public readonly label = input<string>();
  public readonly on = input<boolean | number | string>();
  public readonly off = input<boolean | number | string>();

  public override state: WritableSignal<ToggleRefinementRenderState | undefined> = signal(undefined);

  constructor() {
    super('ToggleRefinement');
  }

  override ngOnInit(): void {
    this.createWidget(connectToggleRefinement as any, {
      attribute: this.attribute(),
      on: this.on(),
      off: this.off(),
    });
    super.ngOnInit();
  }

  handleChange(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.trackEventService.trackClickEvent('toggle_refinement', {
      attribute: this.attribute(),
      isRefined: !this.state()?.value.isRefined
    });
    this.state()?.refine(this.state()?.value);
  }
}
